<template>
  <div v-if="loading == true">
    <v-toolbar color="white" dense flat>
      <v-btn
        icon
        @click="getBack()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="body_naja">
      <div class="progress">
        <div class="color"></div>
      </div>
    </div>
  </div>
  <div v-else>
    <v-toolbar dense flat dark>
      <v-btn
        icon
        @click="getBack()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-toolbar-title
        >Order detail #{{ order_detail.order_code }}</v-toolbar-title
      >
      <v-spacer />
      <v-btn
        class="black--text"
        color="warning"
        @click="approveOrder()"
        :loading="approving"
        :disabled="
          canceling_order ||
          order_detail.order_status == 3 ||
          order_detail.order_status == 4
        "
        v-if="order_detail.order_status == 1"
        >ยืนยันออเดอร์</v-btn
      >
      <v-btn
        dark
        color="success"
        @click="completeOrder()"
        :loading="completing"
        :disabled="
          canceling_order ||
          order_detail.order_status == 3 ||
          order_detail.order_status == 4
        "
        v-else
        >เสร็จสิ้น</v-btn
      >
      <v-btn
        dark
        color="red"
        @click="toCancel()"
        :loading="canceling_order"
        :disabled="
          completing ||
          approving ||
          order_detail.order_status == 3 ||
          order_detail.order_status == 4
        "
        >ยกเลิก</v-btn
      >
    </v-toolbar>
    <v-card class="mt-2">
      <v-card-text>
        <v-layout row wrap>
          <v-flex sm6 xs12>
            <v-card-text>
              <div>
                <div
                  style="
                    font-size: 18px;
                    width: 100%;
                    text-align: center;
                    border-bottom: 1px solid #d9d9d9;
                    line-height: 0.1em;
                    margin: 10px 0 20px;
                    font-weight: bold;
                  "
                >
                  <span style="background: #fff; padding: 0 10px">
                    Order Information</span
                  >
                </div>
                <v-card
                  class="mt-2"
                  flat
                  style="border: 2px solid #e9e9e9; border-radius: 10px"
                >
                  <v-card-text style="font-size: 15px; font-weight: bold">
                    <v-layout wrap>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Order Status :
                        <span
                          style="
                            border-radius: 6px;
                            padding: 0px 10px;
                            color: white;
                            box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
                            white-space: nowrap;
                            font-weight: bold;
                          "
                          :style="{
                            backgroundColor:
                              order_detail.order_status == 1
                                ? '#2196f3'
                                : order_detail.order_status == 2
                                ? 'orange'
                                : order_detail.order_status == 3
                                ? '#4bb543'
                                : 'red',
                          }"
                          >{{
                            order_detail.order_status == 1
                              ? "New Order"
                              : order_detail.order_status == 2
                              ? "On Process"
                              : order_detail.order_status == 3
                              ? "Complete"
                              : "Cancel"
                          }}</span
                        ></v-flex
                      >
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Order Cancel Note :
                        <span
                          style="font-weight: bold"
                          :style="{
                            color: 'red',
                          }"
                          >{{ order_detail.order_note_cancel }}</span
                        ></v-flex
                      >
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Pay by :
                        <span style="color: grey">
                          {{
                            order_detail.order_payment_type == 1
                              ? "COD"
                              : order_detail.order_payment_type == 2
                              ? "Credit/Debit"
                              : order_detail.order_payment_type == 4
                              ? "COIN"
                              : order_detail.order_payment_type == 5
                              ? "AR"
                              : "Other"
                          }}</span
                        >
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Pay status :
                        <span
                          :style="{
                            color:
                              order_detail.order_is_paymented == 1
                                ? 'red'
                                : '#4bb543',
                          }"
                        >
                          {{
                            order_detail.order_is_paymented == 1
                              ? "Unpaid"
                              : "Paid"
                          }}</span
                        >
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Date time Order :
                        <span style="color: grey">
                          {{
                            moment(order_detail.create_at).format(
                              "YYYY-MM-DD HH:mm น."
                            )
                          }}</span
                        >
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Date time Dine in :
                        <span style="color: grey">
                          {{
                            moment
                              .utc(order_detail.order_booking_datetime)
                              .format("YYYY-MM-DD HH:mm น.")
                          }}
                        </span>
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Booking expiration date:
                        <span
                          style="color: grey"
                          v-if="order_detail.order_booking_expried_datetime"
                        >
                          {{
                            moment
                              .utc(order_detail.order_booking_expried_datetime)
                              .format("YYYY-MM-DD")
                          }}</span
                        >
                        <span style="color: grey" v-else>-</span>
                      </v-flex>
                      <v-flex
                        xs12
                        class="mt-2"
                        style="display: flex; justify-content: space-between"
                      >
                        Order note :
                        <span
                          style="color: grey"
                          v-if="order_detail.order_note"
                        >
                          {{ order_detail.order_note }}
                        </span>
                        <span v-else style="color: grey">-</span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </div>
              <div class="mt-5">
                <div
                  style="
                    font-size: 18px;
                    width: 100%;
                    text-align: center;
                    border-bottom: 1px solid #d9d9d9;
                    line-height: 0.1em;
                    margin: 10px 0 20px;
                    font-weight: bold;
                  "
                >
                  <span style="background: #fff; padding: 0 10px">
                    Customer Information</span
                  >
                </div>
                <v-card
                  class="mt-2"
                  flat
                  style="border: 2px solid #e9e9e9; border-radius: 10px"
                >
                  <v-card-text style="font-size: 15px; font-weight: bold">
                    <v-layout wrap>
                      <v-flex xs12>
                        Full name :
                        <span style="color: grey">
                          {{ order_detail.order_customer_name }}</span
                        >
                      </v-flex>
                      <v-flex xs12>
                        Tel. :
                        <span style="color: grey">
                          {{ order_detail.order_customer_tel }}</span
                        >
                      </v-flex></v-layout
                    >
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-flex>
          <v-flex sm6 xs12>
            <v-card-text>
              <div>
                <div
                  style="
                    font-size: 18px;
                    width: 100%;
                    text-align: center;
                    border-bottom: 1px solid #d9d9d9;
                    line-height: 0.1em;
                    margin: 10px 0 20px;
                    font-weight: bold;
                  "
                >
                  <span style="background: #fff; padding: 0 10px">
                    Store Information</span
                  >
                </div>
                <v-card
                  flat
                  style="border: 2px solid #e9e9e9; border-radius: 10px"
                >
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 class="mt-2">
                        <div style="font-size: 15px; font-weight: bold">
                          <label class="mr-1">Store name :</label>
                          <span style="color: grey">
                            {{ order_detail.order_store.store_name }}
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 class="mt-2">
                        <div
                          style="
                            display: flex;
                            font-size: 15px;
                            font-weight: bold;
                          "
                        >
                          <label class="mr-1">Store Tel. :</label>
                          <span style="color: grey">
                            {{ order_detail.order_store.store_tel }}
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 class="mt-2">
                        <div style="font-size: 15px; font-weight: bold">
                          <div class="mr-1">Address :</div>
                          <div style="color: grey">
                            {{ order_detail.order_store.store_addr }}
                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs12 lg6 class="mt-2">
                        <div
                          style="
                            display: flex;
                            font-size: 15px;
                            font-weight: bold;
                          "
                        >
                          <label class="mr-1">Latitude :</label>
                          <span style="color: grey">
                            {{ order_detail.order_store.store_lat }}
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 lg6 class="mt-2">
                        <div
                          style="
                            display: flex;
                            font-size: 15px;
                            font-weight: bold;
                          "
                        >
                          <label class="mr-1">Longitude :</label>
                          <span style="color: grey">
                            {{ order_detail.order_store.store_long }}
                          </span>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-space-between class="mt-3">
                      <v-flex class="mt-3 text-xs-center">
                        <v-btn
                          outline
                          :href="`https://www.google.co.th/maps/dir/${order_detail.order_store.store_lat},${order_detail.order_store.store_long}/data=!4m2!4m1!3e0`"
                          target="_blank"
                          class="black--text"
                          style="border-radius: 6px"
                        >
                          <v-icon class="mr-1" size="18">mdi-map-marker</v-icon>
                          see location
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-flex>
        </v-layout>
        <div class="mt-4 px-3" v-if="order_detail.order_detail.length > 0">
          <div
            style="
              font-size: 18px;
              width: 100%;
              text-align: center;
              border-bottom: 1px solid #d9d9d9;
              line-height: 0.1em;
              margin: 10px 0 20px;
              font-weight: bold;
            "
          >
            <span style="background: #fff; padding: 0 10px">
              Product Information</span
            >
          </div>
          <v-card
            class="mt-2"
            flat
            style="border: 2px solid #e9e9e9; border-radius: 10px"
          >
            <v-card-text style="font-size: 15px; position: relative">
              <v-layout wrap>
                <v-flex xs12 class="mt-2">
                  <span style="font-weight: bold"> Product name:</span>
                  <span>
                    {{ order_detail.order_detail[0].detail_product_name_th }}
                    <span style="color: grey">
                      ({{
                        order_detail.order_detail[0].detail_product_name_en
                      }})</span
                    ></span
                  >
                </v-flex>

                <v-flex xs12 class="mt-2">
                  <span style="font-weight: bold">
                    Description TH :
                  </span></v-flex
                ><v-flex xs12 class="mt-1">
                  <span style="color: grey">
                    {{
                      order_detail.order_detail[0].detail_product_description_th
                    }}</span
                  >
                </v-flex>
                <v-flex xs12 class="mt-2">
                  <span style="font-weight: bold">
                    Description EN :</span
                  > </v-flex
                ><v-flex xs12 class="mt-1">
                  <span style="color: grey">
                    {{
                      order_detail.order_detail[0].detail_product_description_en
                    }}</span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Product quantity:</span>
                  <span>
                    {{ order_detail.order_detail[0].detail_product_quantity }}
                  </span>
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Price per set :</span>
                  <span style="color: grey">
                    {{
                      `฿${order_detail.order_detail[0].detail_product_price}`
                    }}</span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Course amount :</span>
                  <span style="color: grey">
                    {{
                      order_detail.order_detail[0].detail_product_course_amount
                    }}</span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Person :</span>
                  <span style="color: grey">
                    {{
                      order_detail.order_detail[0].detail_product_minimum_person
                    }}
                    -
                    {{
                      order_detail.order_detail[0].detail_product_maximum_person
                    }}</span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Time limit :</span>
                  <span style="color: grey">
                    {{ order_detail.order_detail[0].detail_product_time_limit }}
                    minute</span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Booking expired date :</span>
                  <span style="color: grey">
                    {{
                      moment(
                        order_detail.order_detail[0]
                          .detail_product_booking_expiration
                      ).format("YYYY-MM-DD")
                    }}</span
                  >
                </v-flex>
              </v-layout>
              <v-btn
                fab
                color="error"
                small
                style="position: absolute; top: 40px; right: -20px"
                @click="resendOrderEmail()"
                :loading="resending"
                ><v-icon>notification_important</v-icon></v-btn
              >
              <v-btn
                fab
                color="primary"
                class="black--text"
                small
                style="position: absolute; top: -20px; right: -20px"
                @click="
                  formEditProductDialog = true;
                  selectedProductItem = order_detail.order_detail[0];
                "
                ><v-icon>edit</v-icon></v-btn
              >
            </v-card-text>
          </v-card>
        </div>
        <div class="mt-4 px-3" v-if="order_detail.order_detail.length > 0">
          <div
            style="
              font-size: 18px;
              width: 100%;
              text-align: center;
              border-bottom: 1px solid #d9d9d9;
              line-height: 0.1em;
              margin: 10px 0 20px;
              font-weight: bold;
            "
          >
            <span style="background: #fff; padding: 0 10px"> Reward</span>
          </div>
          <v-card
            class="mt-2"
            flat
            style="border: 2px solid #e9e9e9; border-radius: 10px"
          >
            <v-card-text
              style="font-size: 15px; position: relative"
              v-if="order_detail.order_reward"
            >
              <v-layout wrap>
                <v-flex xs12 class="mt-2">
                  <span style="font-weight: bold"> Reward code:</span>
                  <span>
                    {{ order_detail.order_reward.order_reward_code }}
                  </span>
                </v-flex>
                <v-flex xs12 class="mt-2">
                  <span style="font-weight: bold"> Reward name: </span>
                  <span>
                    {{ order_detail.order_reward.order_reward_name_th }}
                    <span
                      style="color: grey"
                      v-if="order_detail.order_reward.order_reward_name_en"
                    >
                      ({{
                        order_detail.order_reward.order_reward_name_en
                      }})</span
                    >
                  </span></v-flex
                >

                <v-flex xs12 class="mt-2">
                  <span style="font-weight: bold"> Reward description :</span>
                  <span>
                    {{ order_detail.order_reward.order_reward_description_th }}
                    <span
                      style="color: grey"
                      v-if="
                        order_detail.order_reward.order_reward_description_en
                      "
                    >
                      ({{
                        order_detail.order_reward.order_reward_description_en
                      }})</span
                    ></span
                  >
                </v-flex>
                <v-flex xs6 class="mt-2">
                  <span style="font-weight: bold"> Reward discount :</span>
                  <span style="color: grey">
                    ฿{{ order_detail.order_reward.order_reward_discount }}</span
                  >
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text v-else class="text-xs-center"
              >ไม่มีการใช้รีวอร์ด</v-card-text
            >
          </v-card>
        </div>
        <v-divider class="mt-3"></v-divider>
        <div class="mt-4 px-3">
          <div
            style="
              font-size: 18px;
              width: 100%;
              text-align: center;
              font-weight: bold;
            "
          >
            <span
              style="
                background: #fff;
                padding: 0 10px;
                border-bottom: 1px solid black;
              "
            >
              Price Information</span
            >
          </div>
          <v-card class="mt-2" flat>
            <v-card-text
              style="font-size: 15px; display: flex; justify-content: center"
            >
              <div style="width: 80vw; max-width: 600px">
                <table width="100%">
                  <tr style="height: 30px">
                    <td class="text-xs-left">Total price</td>
                    <td width="40%" class="text-xs-right">
                      {{ order_detail.order_sale_price }} THB
                    </td>
                  </tr>
                  <tr style="height: 30px">
                    <td
                      class="text-xs-left"
                      :style="{
                        color: 'red',
                      }"
                    >
                      Discount by WESERVE
                    </td>
                    <td
                      width="40%"
                      class="text-xs-right"
                      :style="{
                        color: 'red',
                      }"
                    >
                      {{ order_detail.order_discount_weserve }} THB
                    </td>
                  </tr>
                  <tr style="height: 30px">
                    <td
                      class="text-xs-left"
                      :style="{
                        color: 'red',
                      }"
                    >
                      Discount by Promotion/Reward
                    </td>
                    <td
                      width="40%"
                      class="text-xs-right"
                      :style="{
                        color: 'red',
                      }"
                    >
                      {{ order_detail.order_discount_by_code }} THB
                    </td>
                  </tr>
                  <tr style="height: 30px">
                    <td
                      class="text-xs-left"
                      :style="{
                        color: 'red',
                      }"
                    >
                      Discount by store
                    </td>
                    <td
                      width="40%"
                      class="text-xs-right"
                      :style="{
                        color: 'red',
                      }"
                    >
                      {{ order_detail.order_discount_by_store }} THB
                    </td>
                  </tr>

                  <tr style="height: 30px; font-size: 16px; font-weight: bold">
                    <td
                      class="text-xs-left"
                      :style="{
                        color: 'green',
                      }"
                    >
                      Net price
                    </td>
                    <td
                      width="40%"
                      class="text-xs-right"
                      style="font-size: 16px; color: green"
                    >
                      {{ order_detail.order_net_price }} THB
                    </td>
                  </tr>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
    <orderLog class="mt-3" :order_detail="order_detail" />
    <formProductDialog
      :dialog="formEditProductDialog"
      :selectedItem="selectedProductItem"
      :storeID="order_detail.order_store.store_id"
      @onClosed="formEditProductDialog = false"
      @onSubmit="editOrderDetail($event)"
      :storeName="order_detail.order_store.store_name"
    />
    <v-dialog v-model="cancelDialog" max-width="60vh">
      <v-card style="border-radius: 6px"
        ><v-card-title style="background-color: black">
          <h2 class="white--text">Cancel Detail</h2>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="validCancelForm" ref="formCancel">
            <v-text-field
              label="Why ?"
              placeholder="Enter cancel note"
              :rules="[(v) => !!v || 'required']"
              hide-details
              v-model="cancelNote"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions
          ><v-spacer></v-spacer
          ><v-btn flat @click="cancelDialog = false" color="error"
            >Cancel</v-btn
          >
          <v-btn color="success" flat @click="cancelOrder()">confirm</v-btn>
        </v-card-actions></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
import orderLog from "@/components/back-office/OrderOnline/OrderDetail/DineIn/OrderLog.vue";
import formProductDialog from "@/components/back-office/OrderOnline/OrderDetail/DineIn/FormProductDialog.vue";
import { mapActions } from "vuex";
export default {
  components: {
    orderLog,
    formProductDialog,
  },
  data() {
    return {
      canceling_order: false,
      completing: false,
      approving: false,
      loading: false,
      date: new Date().toISOString().substr(0, 10),
      order_detail: {},
      formEditProductDialog: false,
      selectedProductItem: {},
      resending: false,
      cancelNote: "",
      cancelDialog: false,
      validCancelForm: true,
    };
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions({
      cancelOrderDineIn: "fetchDineIn/cancelOrder",
      completeOrderDineIn: "fetchDineIn/completeOrder",
      fetchOrderDetailDineIn: "fetchDineIn/fetchOrderDetail",
      updateOrderDetailDineIn: "fetchDineIn/updateOrderDetailDineIn",
      approveOrderDineIn: "fetchDineIn/approveOrder",
      resendEmailDineIn: "fetchDineIn/resendEmailDineIn",
    }),
    async approveOrder() {
      let check = await confirm("Do you want to approve this order ? ");
      if (check == false) return;

      this.approving = true;
      let result = await this.approveOrderDineIn({
        order_id: this.order_detail.order_id,
        order_status: this.order_detail.order_status,
      });
      this.approving = false;

      if (result == true) {
        this.getBack();
      }
      return;
    },
    async completeOrder() {
      let check = await confirm("Do you want to complete this order ? ");
      if (check == false) return;

      this.completing = true;
      let result = await this.completeOrderDineIn({
        order_id: this.order_detail.order_id,
        order_status: this.order_detail.order_status,
      });
      this.completing = false;

      if (result == true) {
        this.getBack();
      }
      return;
    },
    async cancelOrder() {
      if (!this.$refs.formCancel.validate()) return;
      this.cancelDialog = false;
      this.canceling_order = true;
      let result = await this.cancelOrderDineIn({
        order_id: this.order_detail.order_id,
        order_status: this.order_detail.order_status,
        order_note: this.cancelNote,
      });
      console.log(result);
      this.canceling_order = false;

      if (result == true) {
        this.getBack();
      }
      return;
    },
    getBack() {
      if (this.order_detail.order_status == 3) {
        this.$router.replace({
          name: "dineinOrderComplete",
        });
      } else if (this.order_detail.order_status == 4) {
        this.$router.replace({
          name: "dineinOrderCancel",
        });
      } else if (this.order_detail.order_status == 2) {
        this.$router.replace({
          name: "dineinOrderOnProcess",
        });
      } else {
        this.$router.replace({
          name: "dineinOrderNewOrder",
        });
      }
    },
    async fetchData() {
      this.loading = true;
      let result = await this.fetchOrderDetailDineIn({
        order_id: this.$route.params.order_id,
      });
      this.loading = false;
      if (result == false) return;
      this.order_detail = result;
      return;
    },
    async editOrderDetail(e) {
      let response = await this.updateOrderDetailDineIn(e.form);
      e.done();
      if (response == false) return;
      this.order_detail = response;
      this.formEditProductDialog = false;
    },
    async resendOrderEmail() {
      this.resending = true;
      let result = await this.resendEmailDineIn({
        order_id: this.order_detail.order_id,
      });
      this.resending = false;
      if (result == true) alert("Resend email to store successfully");
    },
    toCancel() {
      this.cancelDialog = true;
      this.cancelNote = "";
      this.$refs.formCancel.resetValidation();
    },
  },
  async created() {
    await this.fetchData();
  },
};
</script>

<style>
.time-picker input.display-time {
  border: none;
}
</style>

<style scoped>
.body_naja {
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
}
.progress {
  position: relative;
  height: 10px;
  width: 1110%;
  border: 10px solid #f4a261;
  border-radius: 15px;
  display: flex;
  align-items: center;
}
.progress .color {
  position: absolute;
  background-color: #ffffff;
  width: 0px;
  height: 10px;
  border-radius: 15px;
  animation: progres 0.5s infinite linear;
}
@keyframes progres {
  0% {
    width: 0%;
  }
  25% {
    width: 50%;
  }
  50% {
    width: 75%;
  }
  75% {
    width: 85%;
  }
  100% {
    width: 100%;
  }
}
</style>
